import { defineStore } from "pinia";
import actuationsRepository from "../../../dixieDB/repositories/actuationsRepository";
import actuacionesRepository from "../../../dixieDB/app-offline/repositories/actuacionesRepository";
import { ref } from "vue";

export const useOfflineActuationsStore = defineStore("offlineActuations", () => {
  const offlineCount = ref(0);

  const updateOfflinegCount = (amount) => {
    offlineCount.value = amount;
  };

  const getOfflineActuations = async () => {
    try {
      const amount = await actuationsRepository.getActuationsAmount(actuacionesRepository.getAll());
      updateOfflinegCount(amount);
    } catch (e) {
      console.error("Error al obtener Actuaciones offline:", e);
      return 0;
    }
  };

  return {
    offlineCount,
    updateOfflinegCount,
    getOfflineActuations,
  };
});
